import TopMeetingParticipants from "../TopMeetingParticipants";

export default TopMeetingParticipants;
